import { fromJS } from 'immutable'
import {
  STANDARD_COST_PRICE_EDIT_REQUEST,
  STANDARD_COST_PRICE_EDIT_SUCCESS,
  STANDARD_COST_PRICE_EDIT_FAILURE,
  STANDARD_COST_PRICE_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case STANDARD_COST_PRICE_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case STANDARD_COST_PRICE_EDIT_SUCCESS:
      return state
        .set('updatedStandardCostAndPrice', fromJS(action.payload.updatedStandardCostAndPrice))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case STANDARD_COST_PRICE_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('updatedStandardCostAndPrice', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case STANDARD_COST_PRICE_EDIT_RESET:
      return state
        .delete('updatedStandardCostAndPrice')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/standard-cost-price/standard-cost-price-edit-reducer.js